<template>
    <div class="">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>报价单详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <div class="">
            <div class="form-single">
                <div class="title">询价标题</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.inqryTitle}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">被询价方</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.merchantName}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">报价时间</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.replyTime}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">要求交付期</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.inqryDeliverPeriod}}&nbsp;&nbsp;天</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">交付期</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.deliverPeriod}}&nbsp;&nbsp;天</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系人</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.contactName}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系电话</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.contactTel}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">报价服务</div>
                <div class="content">
                    <div class="table-layout">

                        <el-table :data="priceReplyInfo.servcList" border style="width: 100%;">
                            <el-table-column prop="servcImage" width="150" label="服务图片" align="center">
                                <template slot-scope="rows">
                                    <img :src="rows.row.servcImage"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="服务名称" align="center"></el-table-column>
                            <el-table-column prop="price" label="市场单价(元)" width="150" align="center">
                                <template slot-scope="rows">
                                    <span>{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="replyPrice" label="呈报单价(元)" width="150" align="center">
                                <template slot-scope="rows">
                                    <span>{{parseFloat(rows.row.replyPrice).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>


            <div class="form-single">
                <div class="title">交易规则</div>
                <div class="content">
                    <swb-create-trade-rule :comparedTradeRuleList="comparedTradeRuleList" :type="type" :operate="tradeOperate" :forPriceInqry="forPriceInqry" :forGoods="forGoods" :forServc="forServc" ref="swb_create_trade_rule"></swb-create-trade-rule>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import priceApi from '../../api/price'

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);

    import SwbPriceReplyList from './PriceReplyList';
    Routes.add(SwbPriceReplyList);

    export default{
        name: 'swb-price-reply-info',
        path: '/price/reply/voucher/detail',
        pathOld: '/price/reply/info',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '报价单详情',
        data: function () {
            return {
                priceReplyInfo: {},
                id: null,
                radio: null,
                tableData: null,

                comparedTradeRuleList: [],
                type: 'priceReply',
                tradeOperate: 'chakan',
                forPriceInqry: true,
                forGoods: false,
                forServc: true,
            }
        },
        created: function () {
            let self = this;
            let id = this.$route.query.id;
            self.id = id;
            self.getPriceReplyInfo();
            self.getTradeRuleInfo();
        },
        methods: {
            // 获取报价信息
            getPriceReplyInfo: function () {
                let self = this;
                let id = this.$route.query.id;
                //
                let msgBoxDlg = MsgBox.loading();
                priceApi.getPriceReplyVoucherInfo(id, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.priceReplyInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTradeRuleInfo: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.id;
                priceApi.getPriceReplyTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let priceReplyTermList = result.data;
                        if(priceReplyTermList != null && priceReplyTermList.length > 0) {
                            self.comparedTradeRuleList = priceReplyTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },
            goBack: function () {
                let self = this;
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbPriceReplyList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceReply/PriceReplyInfo.vue